<template>
  <div class="transfer-to-account-input-user">
    <md-input-item
      ref="my_input"
      v-model="payNumber"
      is-virtual-keyboard
      virtual-keyboard-vm="NumberKeyBoard"
      :maxlength="maxlength"
      :placeholder="placeholder"
    >
      <div
        slot="right"
        class="cancelBtn"
        @click="cancelClick"
      >
        <span class="addLine" />
        {{ $t('cancel') }}
      </div>
    </md-input-item>

    <md-number-keyboard
      ref="NumberKeyBoard"
      v-model="isKeyBoardShow"
      type="professional"
      :ok-text="$t('confirm')"
      hide-dot
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import { InputItem, Field, NumberKeyboard, Icon, Button, Dialog } from 'mand-mobile'
import { mapMutations } from 'vuex'
import { payeeUserInfo } from '@/api/common'
import { MOBILE_PHONE_MAX_LENGTH } from '@/constants'

export default {
  name: 'TransferToAccountInputUser',
  components: {
    [InputItem.name]: InputItem,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  data () {
    return {
      placeholder: this.$t('phoneNum'), // 请输入对方手机号转账
      maxlength: MOBILE_PHONE_MAX_LENGTH,
      payNumber: '',
      isKeyBoardShow: true
    }
  },

  mounted () {
    this.$nextTick(() => this.change_addClass(false))
  },
  methods: {
    ...mapMutations(['change_addClass']), // 控制header头部的颜色
    cancelClick () {
      this.$router.back()
    },
    async handleConfirm () {
      try {
        await payeeUserInfo({ mobile: this.payNumber }) // 判断转账信息
        this.$router.push({ name: 'TransferToAccount', query: { payNumber: this.payNumber } })
      } catch ({ message }) {
        message && Dialog.alert({
          content: message,
          confirmText: this.$t('i_know') // 我知道了
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer-to-account-input-user {
  height: 100%;
  padding: 20px;
}

.showCancelBtn {
  background: #fff;
}

.md-field {
  padding: 0;
  border-radius: 32px;
}

.cancelBtn {
  padding-right: 20px;
  box-sizing: border-box;
  border: 0;
  height: 100px;
  font-size: 32px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.addLine {
  height: 60px;
  border: 1px solid #e5e5e5;
  margin-right: 20px;
}

::v-deep .md-field-item-content::before {
  content: none;
}

::v-deep .md-field-item-content {
  border: 1px solid #e5e5e5;
  border-radius: 32px;
  overflow: hidden;
}

::v-deep .md-input-item-fake {
  margin-left: 20px;
}

::v-deep .md-input-item-fake-placeholder {
  margin-left: 20px;
  font-size: 28px;
}
</style>
